import React from 'react';
import { useTranslation } from 'react-i18next';

import { brandIcons } from '../../../config/branding';
import { AvailableGuestChargingHistory } from '../../../interface/partner-interfaces/guest-charging.interface';
import { useAppSelector } from '../../../redux/hooks';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import ToFixedValue from '../../../shared-functions/ToFixedValue';
/**
 * filter
 * @returns {any} The result
 */
function GuestChargingHistory() {
  const { t } = useTranslation('guestCharging');
  const { guestChargingHistory } = useAppSelector((state) => state.partnerGuestCharging);
  const column = [
    {
      label: t('sno'),
      accessorKey: 's_no' as keyof AvailableGuestChargingHistory,
      /**
       * S.No view
       * @param {any} station - The station
       * @param {any} index - The index
       */
      customData: (station: AvailableGuestChargingHistory, index: number) => (
        <div className="table-row-each-data" style={{ alignSelf: 'center' }}>
          {index + 1}
        </div>
      ),
      columnWidth: 50,
    },
    {
      label: t('station'),
      accessorKey: 'stationName' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('facility'),
      accessorKey: 'facility' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('device'),
      accessorKey: 'chargingPointSn' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('date'),
      accessorKey: 'date' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('startTime'),
      accessorKey: 'transactionStartsAt' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('endTime'),
      accessorKey: 'transactionEndsAt' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('duration'),
      accessorKey: 'duration' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
    },
    {
      label: t('unitConsumed'),
      accessorKey: 'powerConsumed' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
      /**
       * Unit consumed view
       * @param {any} currentRow - current row data
       */
      customData: (currentRow: AvailableGuestChargingHistory) => (
        <p>{ToFixedValue(currentRow.powerConsumedInKwh / 1000)}</p>
      ),
    },
    {
      label: t('cost'),
      accessorKey: 'cost' as keyof AvailableGuestChargingHistory,
      sortAllow: false,
      customLabel: (
        <div className="currency-icon">
          <brandIcons.dollarCurrency /> {t('cost')}
        </div>
      ),
      /**
       * Cost view
       * @param {any} currentRow - current row data
       */
      customData: (currentRow: AvailableGuestChargingHistory) => (
        <p>{ToFixedValue(currentRow?.cost)}</p>
      ),
    },
  ];
  return (
    <div className="guest-charging-view">
      <CustomTable header={column} data={guestChargingHistory} />
    </div>
  );
}

GuestChargingHistory.defaultProps = {
  rowId: '',
};

export default GuestChargingHistory;
